<template>
  <nav class="navbar navbar-expand-md navbar-light bg-white w-100 pt-1 ps-1 pe-3 shadow-sm navbar-fixed">
    <div class="container-fluid">
      <router-link :to="{ name: 'zelos.home' }" class="navbar-brand my-auto">
        <img src="@/assets/icons/Zelos.svg" width="48" />

        <span class="fw-bold ms-2">Zelos</span>
      </router-link>

      <ul class="navbar-nav ms-auto mb-2 mb-md-0 me-3">
        <li class="nav-item dropdown my-auto ms-5">
          <img src="@/assets/img/profilbild.png" alt="Profil Bild" class="avatar me-1" />

          <a class="nav-link dropdown-toggle d-inline pe-0" href="#" data-bs-toggle="dropdown" aria-expanded="false">{{ authStore.name }}</a>
          <ul class="dropdown-menu dropdown-menu-end p-0 m-0" style="width: 370px">
            <div class="row mx-0 rounded-bottom-0 dd-header shadow-sm">
              <div class="col-8 px-1 my-auto"><img src="@/assets/icons/1a_connect.png" class="me-1" width="48" /> 1.A Connect GmbH</div>

              <div class="col-4 px-1 my-auto text-end">
                <span class="logout-btn" @click="authStore.logout()"> Abmelden </span>
              </div>
            </div>

            <div class="row mt-2 mx-0">
              <div class="col-5 p-2 d-flex align-items-center justify-content-start">
                <img src="@/assets/img/profilbild.png" alt="Profil Bild" class="avatar-large" />
              </div>

              <div class="col p-2 my-auto">
                <p class="fw-bold mb-1">{{ authStore.name }}</p>
                <p class="text-muted mb-0">{{ authStore.username }}</p>
                <!-- <p class="text-muted mb-2">{{ authStore.email }}</p> -->

                <!-- <p class="mb-1"><a href="http://192.168.10.122:8000/realms/kunde1/account">Profil bearbeiten</a></p> -->
                <p class="mb-1"><router-link :to="{ name: 'settings' }">Einstellungen</router-link></p>
              </div>
            </div>
            <li class="dropdown-item"></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts" setup>
  //#region Imports
  import { useAuthStore } from '@/modules/auth/stores/authStore';
  //#endregion

  const authStore = useAuthStore();
</script>

<style lang="scss" scoped>
  .navbar-fixed {
    position: fixed;
    z-index: 1200;
    top: 0;
    height: 62px;
  }

  img.avatar {
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #2a579b;
    height: 45px;
    width: 45px;
  }

  img.avatar-large {
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid #2a579b;
    height: 96px;
    width: 96px;
  }

  .dd-header {
    background: rgb(242, 243, 248);
    padding: 10px;
    border-radius: 5px;
  }

  .logout-btn:hover {
    cursor: pointer;
    color: #2a579b;
  }
</style>
